import { email as sendEmail } from './send';
import { userAddedToTeamEmailTemplate } from './templates';
import { EMAIL_SENDER } from './constants';

export default (emailAddress, team, role) => sendEmail(
  emailAddress,
  EMAIL_SENDER,
  'Your permissions have changed',
  userAddedToTeamEmailTemplate({ team, role }),
);
